import { render, staticRenderFns } from "./IspezioneDoc.vue?vue&type=template&id=051ca15c&scoped=true&"
import script from "./IspezioneDoc.vue?vue&type=script&lang=ts&"
export * from "./IspezioneDoc.vue?vue&type=script&lang=ts&"
import style0 from "./IspezioneDoc.vue?vue&type=style&index=0&id=051ca15c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051ca15c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardText,VCardTitle,VCol,VIcon,VRow})
